import type { Command, CommandContext } from "./Command";
import { findItem } from "../../inventory/Inventory";
import { withComponent } from "../../world/Entity";
import type { EntityId } from "../../world/Entity";
import type { ClothingSlot } from "../../world/components";

export class EquipItemCommand implements Command {
  constructor(
    private readonly characterId: EntityId,
    private readonly instanceId: string,
    private readonly slot: ClothingSlot,
  ) {}

  execute(context: CommandContext): void {
    const item = findItem(context.world.inventory, this.instanceId);
    if (!item) throw new Error(`Cannot equip unknown inventory item "${this.instanceId}"`);

    context.world.removeFromInventory(this.instanceId, 1);
    context.world.updateEntity(this.characterId, (e) =>
      withComponent(e, "character", (c) => ({
        ...c,
        clothing: { ...c.clothing, [this.slot]: item.definitionId },
      })),
    );
    context.events.emit("character:dressed", { characterId: this.characterId, slot: this.slot, instanceId: this.instanceId });
  }
}
